module.exports = __webpack_public_path__ + "img/phone.40863e18.png";